import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-five-lesson-one-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitFiveLessonOneGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 5, Lesson 1 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 1: Self-Determination Reassessment";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
